<template>
  <!-- 課金マスタ画面 -->
  <v-form ref="p1DialogForm" v-model="valid" lazy-validation>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-card class="ryokins" style="outline: 1px solid black">
            <v-row class="roww">
              <v-col class="coll" cols="12">
                <div class="ryokin">{{ content.title}}</div>
              </v-col>
            </v-row>
            <hr style="border-top: 1px solid black" />
            <v-row>
              <v-col cols="1" />
              <v-col class="qufen">
                <ryou-radio v-model="disRadio" :value="disRadio" :items="radioItems" :rules="radioRules"
                  :disabled="allCtrlFlg"></ryou-radio>
              </v-col>
            </v-row>
            <hr style="border-top: 1px solid black" />
            <v-row>
              <v-col cols="1" />
              <v-col cols="2">
                <div class="kotei">固定料金</div>
              </v-col>
              <v-col cols="6">
                <ryou-input style="padding-top: 20px;" label="固定金額" prepend-icon="mdi-currency-cny" v-model="fixedCost"
                  value="fixedCost" :rules="fixedRules" :maxlength="5" :disabled="fixedFlg||allCtrlFlg">
                </ryou-input>
              </v-col>
            </v-row>
            <hr style="border-top: 1px solid black" />
            <v-row>
              <v-col cols="1" />
              <v-col cols="2">
                <div class="kihon">基本料金</div>
              </v-col>
              <v-col cols="6">
                <ryou-input style="padding-top: 20px;" :label="valu1" prepend-icon="mdi-currency-cny" v-model="baseCost"
                  value="baseCost" :rules="baseRules" :maxlength="5" :disabled="baseFlg||allCtrlFlg">
                </ryou-input>
              </v-col>
            </v-row>
            <v-row>
              <v-spacer></v-spacer>
              <v-col cols="5">
                <ryou-input style="padding-top: 20px;" label="基準１" suffix="" :maxlength="6" v-model="benchmark"
                  value="benchmark" :rules="baseCriteriaRules" :disabled="baseFlg||allCtrlFlg">
                </ryou-input>
              </v-col>
              <v-col cols="1" style="padding-left: 0px;">
                <div class="ika">以下</div>
              </v-col>
              <v-col cols="5">
                <ryou-input style="padding-top: 20px;" :label="monery1" prepend-icon="mdi-currency-cny" :maxlength="5"
                  v-model="baseAmount" value="baseAmount" :rules="baseCriteriaFeeRules" :disabled="baseFlg||allCtrlFlg">
                </ryou-input>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
            <v-row>
              <v-spacer></v-spacer>
              <v-col cols="5">
                <ryou-input style="padding-top: 20px;" label="基準２" suffix="" :maxlength="6" v-model="benchmark2"
                  value="benchmark2" :rules="baseCriteriaRules" :disabled="baseFlg||allCtrlFlg">
                </ryou-input>
              </v-col>
              <v-col cols="1" style="padding-left: 0px;">
                <div class="ika">以下</div>
              </v-col>
              <v-col cols="5">
                <ryou-input style="padding-top: 20px;" :label="monery2" prepend-icon="mdi-currency-cny" :maxlength="5"
                  v-model="baseAmount2" value="baseAmount2" :rules="baseCriteriaFeeRules"
                  :disabled="baseFlg||allCtrlFlg">
                </ryou-input>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
            <v-row>
              <v-spacer></v-spacer>
              <v-col cols="5">
                <ryou-input style="padding-top: 20px;" label="基準３" suffix="" :maxlength="6" v-model="benchmark3"
                  value="benchmark3" :rules="baseCriteriaRules" :disabled="baseFlg||allCtrlFlg">
                </ryou-input>
              </v-col>
              <v-col cols="1" style="padding-left: 0px;">
                <div class="ika">以上</div>
              </v-col>
              <v-col cols="5">
                <ryou-input style="padding-top: 20px;" :label="monery3" prepend-icon="mdi-currency-cny" :maxlength="5"
                  v-model="baseAmount3" value="baseAmount3" :rules="baseCriteriaFeeRules"
                  :disabled="baseFlg||allCtrlFlg">
                </ryou-input>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
            <v-row>
              <v-col cols="1" />
              <v-col cols="2">
                <ryou-black-btn :label="'登録'" :handlerClick="handleOk" :disabled="allCtrlFlg"></ryou-black-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <ryou-confirm ref="confirm"></ryou-confirm>
    </v-container>
  </v-form>
</template>
<script>

  import RyouRadio from "@/components/formInput/RyouRadio.vue";
  import RyouInput from "@/components/formInput/RyouInput.vue";
  import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
  import RyouConfirm from "@/components/dialog/RyouConfirm.vue";
  export default {
    components: {
      RyouBlackBtn,
      RyouRadio,
      RyouInput,
      RyouConfirm
    },
    props: {
      content: {
        type: Object,
        default: () => { },
        required: true,
      },
      componentUrl: {
        type: String,
        required: true,
      }
    },
    data() {
      return {
        allCtrlFlg: true,
        fixedFlg: false,
        baseFlg: false,
        p1DialogForm: true,
        valu1: "",
        monery1: "",
        billingCostUpdateFlg: true,
        radioRules: [],
        fixedRules: [],
        baseRules: [],
        baseCriteriaRules: [],
        baseCriteriaFeeRules: [],
        valid: true,
        disRadio: null,
        monery2: "",
        monery3: "",
        building_id: "",
        fixedCost: "", //固定金額
        baseCost: "", //基本料金
        benchmark: "", //基準1
        benchmark2: "", //基準2
        benchmark3: "", //基準3
        baseAmount: "", //基準1料金
        baseAmount2: "", //基準2料金
        baseAmount3: "", //基準3料金
        dateRules: [],
        radioItems: [
          {
            value: "1",
            label: "固定"
          },
          {
            value: "2",
            label: "重課金"
          },
        ],
      };
    },

    mounted() {
      this.valu1 = this.content.valu1;
      this.monery1 = this.content.monery1;
      this.monery2 = this.content.monery2;
      this.monery3 = this.content.monery3;
    },
    watch: {

      disRadio(val) {
        this.$refs.p1DialogForm.resetValidation();
        this.radioRules.push(this.GlobalRules.required);

        if (val == "1") {
          this.fixedFlg = false;
          this.baseFlg = true;

          this.baseRules = [];
          this.baseCriteriaRules = [];
          this.baseCriteriaFeeRules = [];

          this.fixedRules.push(this.GlobalRules.required);
          this.fixedRules.push(this.GlobalRules.number);
          this.fixedRules.push(this.GlobalRules.currency);

        } else if (val == "2") {
          this.fixedFlg = true;
          this.baseFlg = false;

          this.fixedRules = [];

          this.baseRules.push(this.GlobalRules.required);
          this.baseRules.push(this.GlobalRules.number);
          this.baseRules.push(this.GlobalRules.currency);

          this.baseCriteriaRules.push(this.GlobalRules.required);
          this.baseCriteriaRules.push(this.GlobalRules.number);
          this.baseCriteriaRules.push(this.GlobalRules.numberMax1000);
          this.baseCriteriaRules.push(this.GlobalRules.number_point_2);

          this.baseCriteriaFeeRules.push(this.GlobalRules.required);
          this.baseCriteriaFeeRules.push(this.GlobalRules.number);
          this.baseCriteriaFeeRules.push(this.GlobalRules.currency);
        }
        else {
          this.fixedFlg = false;
          this.baseFlg = false;

          this.fixedRules.push(this.GlobalRules.number);
          this.fixedRules.push(this.GlobalRules.currency);

          this.baseRules.push(this.GlobalRules.number);
          this.baseRules.push(this.GlobalRules.currency);

          this.baseCriteriaRules.push(this.GlobalRules.number);
          this.baseCriteriaRules.push(this.GlobalRules.numberMax1000);
          this.baseCriteriaRules.push(this.GlobalRules.number_point_2);

          this.baseCriteriaFeeRules.push(this.GlobalRules.number);
          this.baseCriteriaFeeRules.push(this.GlobalRules.currency);
        }
      }
    },
    methods: {
      handleOk() {
        var valid = this.$refs.p1DialogForm.validate();

        var strs = this.componentUrl;
        if (valid && this.building_id != "") {
          if (this.billingCostUpdateFlg) {

            this.$refs.confirm.open("更新", "更新します。宜しいですか？", { color: "info" }).then((confirm) => {

              if (confirm) {
                let params = null;
                if (this.disRadio == "1") {
                  params = {
                    user_id: this.$store.getters.getUserId,
                    building_id: this.building_id,
                    use_class: this.disRadio,
                    basic_fee: this.fixedCost,
                  };
                }
                else if (this.disRadio == "2") {
                  params = {
                    user_id: this.$store.getters.getUserId,
                    building_id: this.building_id,
                    use_class: this.disRadio,
                    basic_fee: this.baseCost,
                    criteria1: this.benchmark,
                    criteria2: this.benchmark2,
                    criteria3: this.benchmark3,
                    criteria1_fee: this.baseAmount,
                    criteria2_fee: this.baseAmount2,
                    criteria3_fee: this.baseAmount3,
                  };
                }


                  this.putRequest("/masterBilling/" + strs + "CostUpdate", params, this.$store.getters.getUserToken).then((resp) => {
                  if (resp.success) {
                    this.$emit("ok");
                  }
                });
              }
            });
          } else {
            this.$refs.confirm.open("登録", "登録します。宜しいですか？", { color: "info" }).then((confirm) => {


              if (confirm) {
                let insertParams = null;

                if (this.disRadio == "1") {
                  insertParams = {
                    user_id: this.$store.getters.getUserId,
                    building_id: this.building_id,
                    use_class: this.disRadio,
                    basic_fee: this.fixedCost,
                  };
                }
                else if (this.disRadio == "2") {
                  insertParams = {
                    user_id: this.$store.getters.getUserId,
                    building_id: this.building_id,
                    use_class: this.disRadio,
                    basic_fee: this.baseCost,
                    criteria1: this.benchmark,
                    criteria2: this.benchmark2,
                    criteria3: this.benchmark3,
                    criteria1_fee: this.baseAmount,
                    criteria2_fee: this.baseAmount2,
                    criteria3_fee: this.baseAmount3,
                  };
                }
                  this.postRequest("/masterBilling/" + strs + "CostInsert", insertParams, this.$store.getters.getUserToken).then((resp) => {
                  if (resp.success) {
                    this.billingCostUpdateFlg = true;
                    this.$emit("ok");
                  }
                });
              }
            });
          }
        }
      },

      BillingValueSet(value) {
        let params = {
          building_id: value,
        };
        if (value != "") {
          this.allCtrlFlg = false;
        }
        var strs = this.componentUrl;
        var that = this;
          this.getRequest("/masterBilling/" + strs + "CostGet", params, this.$store.getters.getUserToken).then((data) => {
          // 取得
          if (data.success && data.result.length != 0) {
            that.billingCostUpdateFlg = true;
            that.building_id = data.result[0].building_id;
            that.disRadio = data.result[0].use_class;
            that.fixedCost = data.result[0].basic_fee;
            that.baseCost = data.result[0].basic_fee;
            that.benchmark = data.result[0].criteria1;
            that.benchmark2 = data.result[0].criteria2;
            that.benchmark3 = data.result[0].criteria3;
            that.baseAmount = data.result[0].criteria1_fee;
            that.baseAmount2 = data.result[0].criteria2_fee;
            that.baseAmount3 = data.result[0].criteria3_fee;


          } else {

            that.billingCostUpdateFlg = false;
            that.building_id = value;
            that.disRadio = "";
            that.fixedCost = null;
            that.baseCost = null;
            that.benchmark = null;
            that.benchmark2 = null;
            that.benchmark3 = null;
            that.baseAmount = null;
            that.baseAmount2 = null;
            that.baseAmount3 = null;
          }
        });
      },

      open() {
        if (this.$refs.p1DialogForm) {

          this.$refs.p1DialogForm.reset();
          this.$refs.p1DialogForm.resetValidation();
        }
      },
    },
  };
</script>
<style>
  .select {
    height: 150px;
    padding: 40px;
  }

  .detail {
    padding: 50px;
  }

  .costKotei {
    padding-top: 20px;
  }

  .buken {
    width: 90px;
    height: 60px;
    padding-top: 2%;
  }

  .bukens {
    width: 350px;
    height: 80px;
  }

  .buken,
  .bukens {
    float: left;
    box-sizing: border-box;
  }

  .copy {
    width: 150px;
    height: 60px;
    padding-top: 2%;
  }

  .copys {
    width: 350px;
    height: 80px;
  }

  .copy,
  .copys {
    float: left;
    box-sizing: border-box;
  }

  .roww {
    padding-top: 0%;
  }

  .coll {
    height: 60px;
    padding-top: 0%;
  }

  .ryokin {
    padding: 0%;
    height: 60px;
    text-align: center;
    font-size: 20px;
    line-height: 60px;
    background-color: red;
  }

  .qufen {
    height: 70px;
  }

  .kotei,
  .kihon,
  .ika {
    width: 90px;
    height: 70px;
    line-height: 70px;
    padding-top: 5px;
  }
</style>